<style type="text/css" media="screen">
.scrolable-box-2{
	min-height: 280px;
	max-height:280px;
	overflow-y:scroll;
}
</style>
<template>
	<div>
		<!-- confirmation dialog  for chnage  Agent  status -->
		<v-dialog v-model="dialog.flag" width="560" >
			<v-card>
				<p class="text-right pr-3" style="margin-bottom:-10px !important">
					<v-icon color="#8F8F8F" small @click="dialog.flag=false">
						mdi-window-close
					</v-icon>
				</p>
				<v-card-title class="headline flex-column lighten-2" primary-title >
					<p class="page-title text-center">{{$lang.MERGE_WITH}}?</p>
				</v-card-title >
				<v-card-text class="flex-column text-center mb-5">
					<p class="secodry-text-2 text-center">{{$lang.MERGE_MSG}}</p>
					<v-row>
						<v-col cols="9" md="8" class="custome-form">
							<v-text-field
							v-model="retailer_serch_query"
							:placeholder="$lang.SEARCH"
							@keyup="getRetailerList"
							outlined
							dense
							rounded
							append-icon="mdi-magnify"
							class="mt-1"
							height="31px"
							hide-details
							></v-text-field>
						</v-col>
					</v-row>
					<div class="scrolable-box-2 text-left" v-if="retailer_list.length==0">
						<span class="secodry-text-2">{{$lang.NO_RETAILER_FOUND}}</span>
					</div>
					<div class="scrolable-box-2" v-else>
						<v-checkbox 
						v-for="retailer in retailer_list" 
						:key="retailer.retailer_id"
						v-model="retailer_id_list" 
						:label="retailer.retailer_firm_name"
						:value="retailer.retailer_id"
						@change="singleSelect(retailer)"
						class="ml-2 mt-0 custome-checkbox">
						<template v-slot:label>

							<v-row  class="mx-0">
								<v-col cols="9" md="7" class="py-0">
									<p class="sub-title-text-dark">{{retailer.retailer_firm_name}}</p>
									<p class="select-secondary-text">{{retailer.retailer_full_address}}</p>
								</v-col>
								<v-col cols="12" md="5" class="py-0">
									<p class="sub-title-text-dark">{{retailer.retailer_mobile_number}}</p>
									
								</v-col>
							</v-row>
						</template>
					</v-checkbox>

				</div>

			</v-card-text>

			<v-card-actions class="text-center pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary" width="180" class="fw-bold" :loading="btn_loading" :disabled="retailer_id_list.length==0?true:false" @click="merge">	
					{{$lang.MERGE}}
				</v-btn>	
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
export default{
	props:['dialog','retailer_id'],
	data(){
		return{
			btn_loading:false,
			retailer_serch_query:"",
			retailer_list:[],
			retailer_id_list:[],
		}
	},
	methods:{
		/* get retailer list */
		getRetailerList(){
			const self=this
			let params={
				"search_query":self.retailer_serch_query,
				"merge":"Yes",
			};
			self.loading=true;
			const successHandler = (response) => {
				console.log(response)
				self.retailer_list=response.data.retailer_list

			};
			const finallyHandler = () => {
				self.loading=false
			};
			self.request_GET( self,self.$urls.RETAILER_MANAGE_LIST,params,successHandler,null,null,finallyHandler)
		},
		singleSelect(retailer){
			this.retailer_id_list=[]
			this.retailer_id_list.push(retailer.retailer_id)
		},
		merge(){
			const self=this
			self.btn_loading=true
			var	form = new FormData();
			form.append("old_retailer_id",self.retailer_id_list[0])
			form.append("new_retailer_id",self.retailer_id)
			let url=this.$urls.REGISTER_RETAILER
			const successHandler = (response) => {
				if (response.data.success){
					this.dialog.flag=false
					this.$router.push({name:'manage-retailers'})
				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};

			this.request_POST(self,self.$urls.MERGE_RETAILER,form,successHandler,null,null,finallyHandler)


		}

	}
}

</script>